import { Component, inject } from '@angular/core';
import { UserStore } from '../../../stores/user.store';
import { HeaderComponent } from '../../molecules/header/header.component';
import { NavigationBarComponent } from '../../molecules/navigation-bar/navigation-bar.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  imports: [HeaderComponent, NavigationBarComponent],
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private userStore = inject(UserStore);
  public user = this.userStore.user;
}
